import { render, staticRenderFns } from "./specificBlogDetail.vue?vue&type=template&id=1c15b090&scoped=true&"
import script from "./specificBlogDetail.vue?vue&type=script&lang=js&"
export * from "./specificBlogDetail.vue?vue&type=script&lang=js&"
import style0 from "./specificBlogDetail.vue?vue&type=style&index=0&id=1c15b090&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c15b090",
  null
  
)

export default component.exports